
import PromotionalSlideshowMobile from './PromotionalSlideshowMobile.vue';
import PromotionalSlideshowMobileSlide from './PromotionalSlideshowMobileSlide.vue';
import ReferallList from '~/components/generic/ReferallList.vue';
import ReferallListItem from '~/components/generic/ReferallListItem.vue';

export default {
  components: { PromotionalSlideshowMobile, PromotionalSlideshowMobileSlide, ReferallList, ReferallListItem }

};
